import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { SvgIconHandler } from "../../atoms/svg-icon-hadler";
import CheckboxIcon from "../../../../assets/icons/CheckboxIcon";
import UncheckedIcon from "../../../../assets/icons/UncheckedIcon";

import "./section-filter.m.css";

const SectionFilter = ({ isVisible, onClose, onApply, initialSelectedSections = [] }) => {
  const [selectedSections, setSelectedSections] = useState(initialSelectedSections);
  const sections = useSelector(state => {
    const allSections = state.qt.config.sections || [];
    return allSections.filter(section =>
      ![
        'events',
        'conferences',
        'workshops',
        'sessions',
        'events-landing',
        'test',
        'sample-stories',
        'ceo-forum-slide',
        'cfo-forum-slider',
        'cfo-nxt-forum-slider',
        'chro-forum-slider',
        'cmo-forum-slider',
        'about-ima',
        'forum-pages-static',
        'getting-started',
        'headline-image-text',
        'isf-forum-slider',
      ].includes(section.slug)
    );
  });
  sections?.sort((a, b) => a.name.localeCompare(b.name));

  useEffect(() => {
    setSelectedSections(initialSelectedSections);
  }, [initialSelectedSections]);

  const handleSectionToggle = (sectionId) => {
    setSelectedSections(prev => {
      if (prev.includes(sectionId)) {
        return prev.filter(s => s !== sectionId);
      } else {
        return [...prev, sectionId];
      }
    });
  };


  const handleApply = () => {
    onApply(selectedSections);
    onClose();
  };

  const handleReset = () => {
    setSelectedSections([]);
    onApply([]); // Trigger search with no sections
    onClose();
  };

  if (!isVisible) return null;

  return (
    <div styleName="filter-overlay" onClick={onClose}>
      <div styleName="filter-modal" onClick={(e) => e.stopPropagation()}>
        <div styleName="filter-header">
          <h2 styleName="filter-title">Filters</h2>
          <div styleName="filter-actions">
            <button styleName="reset-button" onClick={handleReset}>
              Reset
            </button>
            <button styleName="apply-button" onClick={handleApply}>
              Apply
            </button>
            <button styleName="close-button" onClick={onClose} aria-label="Close filter">
              <SvgIconHandler type="close" width="12" height="12" />
            </button>
          </div>
        </div>

        <div styleName="filter-content">
          <div styleName="filter-items-container">
            {sections.map((section) => (
              <label
                key={section.id}
                styleName="option-item"
              >
                <input
                  type="checkbox"
                  styleName="checkbox"
                  checked={selectedSections.includes(String(section.id))}
                  onChange={() => handleSectionToggle(String(section.id))}
                />
                {selectedSections.includes(String(section.id)) ? (
                  <CheckboxIcon />
                ) : (
                  <UncheckedIcon />
                )}
                <span styleName="option-label">{section["display-name"] || section.name}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Mobile fixed bottom buttons */}
        <div styleName="mobile-buttons">
          <button styleName="mobile-reset-button" onClick={handleReset}>
            Reset
          </button>
          <button styleName="mobile-apply-button" onClick={handleApply}>
            Apply
          </button>
        </div>

      </div>
    </div>
  );
};

SectionFilter.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  initialSelectedSections: PropTypes.array,
};

export { SectionFilter };